import { ContentContainer } from "@/components/ContentContainer";
import { NetworkFaq } from "@/components/network";
import Grid from "@mui/material/Grid";
import { useEffect } from "react";
import PageHead from "@/components/PageHead";

export default function FAQ({page}) {

  return (
    <>
      <PageHead page={page} />

      <ContentContainer
        headline={page.headline}
        image={page.heroimage?.formats?.large?.url}
      >
        <Grid container>
          <Grid item xs={12}>
            {page.entries.map((entry, idx) => {
              return (
                  <NetworkFaq
                    key={idx}
                    question={entry.title}
                    answer={entry.content}
                  />
              );
            })}
          </Grid>
        </Grid>
      </ContentContainer>
    </>
  );
}

export const getStaticProps = async() => {
  const pageResponse = await fetch(`${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}/page-faq`);
  const page = await pageResponse.json();

  return {
    props: {
      page
    },
    revalidate: parseInt(process.env.SSG_REVALIDATE_TIMEOUT)
  }
}